import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de6e82d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-detail" }
const _hoisted_2 = { class: "item text-overflow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司首编码：", -1))
const _hoisted_4 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司全称：", -1))
const _hoisted_6 = { class: "item text-overflow" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司简称：", -1))
const _hoisted_8 = { class: "register-detail" }
const _hoisted_9 = { class: "item text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司简称首拼：", -1))
const _hoisted_11 = {
  class: "item text-overflow",
  style: {"width":"500px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司简称全拼：", -1))
const _hoisted_13 = { class: "register-detail" }
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司VP姓名：", -1))
const _hoisted_16 = { class: "long-item text-overflow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "法人：", -1))
const _hoisted_18 = { class: "register-detail" }
const _hoisted_19 = { class: "item text-overflow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "工位数量：", -1))
const _hoisted_21 = { class: "long-item text-overflow" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "所在城市：", -1))
const _hoisted_23 = { class: "register-detail" }
const _hoisted_24 = { class: "long-item text-overflow" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "所属大区：", -1))

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import { companyAccountDetail } from "@/api/process_company";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }




let form = ref({
  CompanyName: "",
  FullName: "",
  Quanpin: "",
  Shoupin: "",
  ManagerStaffId: 0,
  ManagerStaffName: "",
  PrefixCode: "",
  StationNumber: 0,
  LegalStaffId: 0,
  LegalStaffName: "",
  LocationCode: "",
  LocationName: "",
  RegionName: "",
});

watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);

const getdata = async () => {
  const { Data } = await companyAccountDetail({
    Id: props.folwId,
  });
  if (Data?.PageData) {
    form.value.CompanyName = Data?.PageData.CompanyName || "";
    form.value.FullName = Data?.PageData.FullName || "";
    form.value.Quanpin = Data?.PageData.Quanpin || "";
    form.value.Shoupin = Data?.PageData.Shoupin || "";
    form.value.ManagerStaffId = Data?.PageData.ManagerStaffId || "";
    form.value.ManagerStaffName = Data?.PageData.ManagerStaffName || "";
    form.value.PrefixCode = Data?.PageData.PrefixCode || "";
    form.value.StationNumber = Data?.PageData.StationNumber || "";
    form.value.LegalStaffId = Data?.PageData.LegalStaffId || "";
    form.value.LegalStaffName = Data?.PageData.LegalStaffName || "";
    form.value.LocationCode = Data?.PageData.LocationCode || "";
    form.value.LocationName = Data?.PageData.LocationName || "";
    form.value.RegionName = Data?.PageData.RegionName || "";
    form.value.RegionId = Data?.PageData.RegionId || "";
  }

  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};
onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_unref(form).PrefixCode), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_unref(form).FullName), 1)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_unref(form).CompanyName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_unref(form).Shoupin), 1)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(form).Quanpin), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_unref(form).Quanpin), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", null, _toDisplayString(_unref(form).ManagerStaffName), 1)
      ]),
      _createElementVNode("span", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("span", null, _toDisplayString(_unref(form).LegalStaffName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("span", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("span", null, _toDisplayString(_unref(form).StationNumber), 1)
      ]),
      _createElementVNode("span", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("span", null, _toDisplayString(_unref(form).LocationName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("span", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("span", null, _toDisplayString(_unref(form).RegionName), 1)
      ])
    ])
  ], 64))
}
}

})